import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { EventWithVenue } from "../../models";
import { UnsafeAction } from "../../actions/UnsafeAction";

/* tslint:disable */
@Injectable()
export class EventsOnSaleActions {

	static EVENTS_ON_SALE_LOADED = '[EventsOnSale] collection loaded';
	collectionLoaded(eventsWithVenue:EventWithVenue[]): UnsafeAction {
		return {
			type: EventsOnSaleActions.EVENTS_ON_SALE_LOADED,
			payload:eventsWithVenue
		};
	}

	static EVENTS_ON_SALE_SEARCH = '[EventsOnSale] collection search';
	search(search: {}): UnsafeAction{
		return {
			type: EventsOnSaleActions.EVENTS_ON_SALE_SEARCH,
			payload:search
		};
	}

static EVENTS_ON_SALE_ORDER = '[EventsOnSale] collection order';
	orderBy(orderBy: string): UnsafeAction{
		return {
			type: EventsOnSaleActions.EVENTS_ON_SALE_ORDER,
			payload:orderBy
		};
	}


}


// WEBPACK FOOTER //
// ./src/app/components/events-on-sale/events-on-sale.actions.ts